import { Col } from "antd";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import pageJson from "./search-data/pt_BR.json";
import { match } from "path-to-regexp";

export default function HeaderText() {
  const { pathname } = useLocation();
  const [titleFix, setTitleFix] = useState("Dashboard");

  useEffect(() => {
    let matchedTitle = "Dashboard";

    for (const page of pageJson) {
      const isMatch = match(page.url, { decode: decodeURIComponent });
      if (isMatch(pathname)) {
        matchedTitle = page.title;
        break;
      }
    }

    setTitleFix(matchedTitle.replace("Dashboard ", ""));
  }, [pathname]);

  return (
    <Col xl={16} lg={14} className="hp-header-left-text hp-d-flex-center">
      <h1 className="hp-mb-0">{titleFix}</h1>
    </Col>
  );
}
